import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {MinimumGamblingAgeDefaultBox} from "./minimum-gambling-age.default.box";

export const MinimumGamblingAgeBox = styledByTheme(MinimumGamblingAgeDefaultBox)
    .apply();